import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectWorkTypeValue } from '../../../../services/workTypes/selectors';

interface Props {
    entityTypeId: number;
    children: React.Element<any> | Function;
}

export class WorkTypeEntityTypeId extends React.PureComponent<Props> {
    render() {
        const { children, entityTypeId } = this.props;

        if (typeof children === 'function') {
            return children(entityTypeId);
        }

        return React.cloneElement(children, { entityTypeId });
    }
}

const mapStateToProps = createStructuredSelector({
    entityTypeId: makeSelectWorkTypeValue('entityTypeId')
});

export default connect(mapStateToProps)(WorkTypeEntityTypeId);
